export * from "components/NavBarSearch/hooks/useSearchTerm";
